import {
  SERVICE_PROVIDER_IMPORT_BY_CSV,
  USER_IMPORT_BY_CSV,
} from "../services/ApiCalls";
import URLS from "../services/URLS";
import { makingOptionsFromArr } from "./utilities";

export const statusEnum = {
  requested: { label: "Requested", value: "requested" },
  cancelled: { label: "Cancelled", value: "cancelled" },
  rejected: { label: "Rejected", value: "rejected" },
  pickUpSchedule: { label: "Pickup-Schedule", value: "pickUpScheduled" },
  orderPickedUp: { label: "Order Picked up", value: "orderPickedUp" },
  pending: { label: "Payment Pending", value: "pending" },
  confirmed: { label: "Confirmed", value: "confirmed" },
  inProcess: { label: "Service in process", value: "inroute" },
  outForDelivery: { label: "Out For Delivery", value: "OutForDelivery" },
  completed: { label: "Completed", value: "completed" },
};

export const paginationLimitArr = [5, 10, 20, 50, 100, 200, 500, 1000];

export const orderStatusArr = ["pending", "completed", "ongoing", "cancelled"];

export const defaultDeleteModelState = {
  show: false,
  dumpId: "",
};

export const activeInactiveOptions = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Active",
    value: "active",
  },
  {
    label: "InActive",
    value: "inactive",
  },
];
export const AdminStatusOptionSubscription = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Active",
    value: "active",
  },
  {
    label: "In Active",
    value: "inactive",
  },
];

export const csvImportEnum = {
  users: {
    title: "Users",
    sampleUrl: URLS.BASE_URL + "/public/csv/import_user.csv",
    api: (data) => USER_IMPORT_BY_CSV(data),
  },
  serviceProvider: {
    title: "THERAPIST",
    sampleUrl: URLS.BASE_URL + "/public/csv/import_vendor.csv",
    api: (data) => SERVICE_PROVIDER_IMPORT_BY_CSV(data),
  },
};

export const activeInActiveArr = ["active", "inactive"];
export const accountType = [
  { label: "Individual Account", value: "single" },
  { label: "Business Account", value: "enterprise" },
];

export const discountTypeArr = ["percent", "flat"];

export const adminTypeArr = ["admin", "sub-admin"];

export const earningTabArr = ["week", "month", "year"];

export const userTypeOptions = [
  {
    label: "All",
    value: "",
  },
  {
    label: "User",
    value: "user",
  },
  {
    label: "Therapist",
    value: "vendor",
  },
];

export const earningTypeOptions = [
  {
    label: "All",
    value: "all",
  },
  {
    label: "Category",
    value: "category",
  },
  {
    label: "Therapist",
    value: "vendor",
  },
];

export const typeOptionsArray = [
  {
    label: "User",
    value: "customers",
  },
  {
    label: "Therapist",
    value: "vendors",
  },
];
